export default "__VITE_ASSET__Dq7zpMW0__"